import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Map, ZoomControl, Marker, Popup, LayerGroup } from 'react-leaflet';
import TileLayer from './TileLayer';
import { getMapProps, getIcon } from './mapUtil';
import { useContainerRect } from '../../hooks';
import styles from './Viewer.module.scss';
import 'leaflet/dist/leaflet.css';
import { get } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { toggleIcon } from './LegendControl/legend.store';
import { useLegendControl } from './LegendControl';
import { types } from '@babel/core';
import { monsters } from './icons';
import marker from './images/marker.svg';

const legends = ['heart', 'phone',  'monster', 'seashell','moneyBag', 'house'];

const icon = legends.reduce((accum: any, e: any) => {
  return {
    ...accum,
    [e]: getIcon(e),
    [`${e}_done`]: getIcon(e, true),
  };
}, {});

// const icon = {
//   heart: getIcon('heart'),
//   moneyBag: getIcon('moneyBag'),
//   monster: getIcon('monster'),
//   phone: getIcon('phone'),
//   seashell: getIcon('seashell'),
// };

const iconTypes = Object.keys(icon);

const layerGroups = monsters.reduce((accum: any, e: any) => {
  return {
    ...accum,
    [e.type]: [...(accum[e.type] || []), e],
  };
}, {});

function Viewer({ data }: any) {
  const done = useSelector((state) => get(state, ['legend', 'done']));

  const dispatch = useDispatch();

  const ref = useRef<any>();
  const rect: any = useContainerRect(ref, ['width', 'height']);

  const mapProps: any = useMemo(() => getMapProps(data, rect), [data, rect]);

  const handleMarkerClick = (event: any) => {
    // console.log('>>> handleMarkerClick');
    // console.log(event.target.options.id);

    dispatch(toggleIcon(event.target.options.id));
  };

  // onClick={this.handleClick}
  // console.log()
  const [center, setCenter] = useState({});
  const handleMapClick = useCallback((e: any) => {
    // console.log(e.target._zoom);
    const { latlng } = e;
    // console.log(latlng);

    // console.log([latlng.lat, latlng.lng]);

    setCenter({
      zoom: e.target._zoom,
      center: [latlng.lat, latlng.lng],
    });
  }, []);

  const [aaa, LegendControl] = useLegendControl(legends);
  return (
    <div className={styles.root} ref={ref}>
      {/* <pre>{JSON.stringify(aaa)}</pre> */}
      {mapProps && (
        <Map
          {...mapProps}
          // center={center || mapProps.center}
          {...center}
          // onClick={handleMapClick}
        >
          <TileLayer {...data} />

          {aaa.map((f: string) => {
            return layerGroups[f] ? (
              <LayerGroup>
                {layerGroups[f].map((e: any) => {
                  // console.log(e)
                  return (
                    <Marker
                      icon={icon[`${f}${done[e.id] ? '_done' : ''}`]}
                      id={e.id}
                      position={e.position}
                      onClick={handleMarkerClick}
                    >
                      {/* <Popup>
            A pretty CSS3 popup.
            <br />
            <button onClick={handleClick}>test</button>
            Easily customizable.
          </Popup> */}
                    </Marker>
                  );
                })}
              </LayerGroup>
            ) : null;
          })}

          <ZoomControl position="bottomright" />
          <LegendControl position="topright" />
        </Map>
      )}
    </div>
  );
}

// function Last () {

//   return (
//     <LegendControl position="topleft">
//     <div>test case here
//       <ul>
//         {iconTypes.map((e:string) => {
//           return (<li>
//             <i className={`icon-${e}`} />
//           </li>)
//         })}

//       </ul>

//       {/* <button onClick={handleClick}>test</button> */}
//     </div>
//   </LegendControl>
//     )

// }

export default Viewer;
